import { Component } from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { EMPTY } from 'rxjs';

import { BaseFormComponent, FormManagerService } from '@sim/form';
import { Media } from '@sim/media';

import { SourceBibApiService } from '@atmi/core';
import { SourceBibliographic, SourceBibliographicMeta } from '@atmi/core/models';
import { Status } from '@atmi/core/models/status';
import { separatorKeysCodes } from '@atmi/core/utils';

@Component({
  selector: 'app-source-bibliographic-manager',
  styleUrls: ['./source-bibliographic-manager.component.scss'],
  templateUrl: './source-bibliographic-manager.component.html',
})
export class SourceBibliographicManagerComponent extends BaseFormComponent<SourceBibliographic> {

  readonly separatorKeysCodes = separatorKeysCodes;

  constructor(
    protected readonly snackBarService: MatSnackBar,
    protected readonly translate: TranslateService,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly formManager: FormManagerService,
    protected readonly spinner: NgxSpinnerService,
    private readonly sourceBibApi: SourceBibApiService
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      undefined,
      SourceBibliographicMeta,
      (id) => sourceBibApi.get(id as string),
      '/bibs-sources',
      router,
    );

  }

  addConcrete(sourceBib: SourceBibliographic) {
    return this.sourceBibApi.post(sourceBib);
  }

  removeConcrete(sourceBib: SourceBibliographic) {
    if (sourceBib.id) {
      return this.sourceBibApi.remove(sourceBib.id);
    }
    return EMPTY;
  }

  editConcrete(sourceBib: SourceBibliographic) {
    return this.sourceBibApi.put(sourceBib);
  }

  resetFormConcrete() {
    return EMPTY;
  }

  updateImageHandler(media: Media | undefined) {
    if (!this.entityControls) {
      throw new Error('Cannot set image');
    }

    if (!this.entityControls.immagine) {
      throw new Error('Cannot set image without a valid control');
    }

    if (media) {
      this.entityControls.immagine.setValue(media.id);
    } else {
      this.entityControls.immagine.setValue(undefined);
    }
  }

  updateFileHandler(media: Media | undefined) {
    if (!this.entityControls) {
      throw new Error('Cannot set file');
    }

    if (!this.entityControls.file) {
      throw new Error('Cannot set file without a valid control');
    }

    if (media) {
      this.entityControls.file.setValue(media.id);
    } else {
      this.entityControls.file.setValue(undefined);
    }
  }

  changeStatusHandler(status: Status) {
    if (!this.entityControls) {
      throw new Error('Cannot set status without a valid controls');
    }
    if (!this.entityControls.status) {
      throw new Error('Cannot set status without a valid control');
    }
    this.entityControls.status.setValue(status);
    this.entityControls.status.updateValueAndValidity();
  }

  removeTagHandler(tagForm: UntypedFormArray, index: number) {
    if (!tagForm.controls) {
      throw new Error('Cannot manage input without a control');
    }

    tagForm.removeAt(index);
  }

  addTagHandler(tagForm: UntypedFormArray, event: MatChipInputEvent, inputTag: HTMLInputElement): void {
    const value = (event.value || '').trim();
    if (!value) {
      return;
    }
    const control = new UntypedFormControl(value);

    tagForm.push(control);

    inputTag.value = '';
  }
}
